import { render } from "./AccessView.vue?vue&type=template&id=51cad4ce"
import script from "./AccessView.vue?vue&type=script&lang=js"
export * from "./AccessView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__